// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=UTF-8,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27currentColor%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3e%3cpolyline points=%276 9 12 15 18 9%27%3e%3c/polyline%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/routes/Forms/AdminPortal/Receptionist/Receptionist.css */

.receptionist-container {
    max-width: 1280px;
    min-height: calc(100vh - 12vh);
    margin: 0 auto;
    padding: 24px;
    background: linear-gradient(180deg, #f4f7fb 0%, #eef4f8 100%);
    color: #243447;
    box-sizing: border-box;
    position: relative;
    overflow: hidden;
}

.receptionist-container::before {
    content: '';
    position: absolute;
    inset: 0;
    background:
        linear-gradient(135deg, rgba(239, 111, 83, 0.12), transparent 28%),
        linear-gradient(315deg, rgba(25, 118, 210, 0.1), transparent 34%);
    pointer-events: none;
}

.receptionist-container > * {
    position: relative;
    z-index: 1;
}

.receptionist-container *,
.receptionist-container *::before,
.receptionist-container *::after {
    box-sizing: border-box;
}

.receptionist-page-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 18px;
    padding: 22px 24px;
    margin-bottom: 20px;
    border: 1px solid rgba(54, 76, 99, 0.08);
    border-radius: 8px;
    background:
        linear-gradient(180deg, rgba(255, 255, 255, 0.98), rgba(248, 251, 255, 0.96)),
        linear-gradient(90deg, rgba(239, 111, 83, 0.1), rgba(25, 118, 210, 0.08));
    box-shadow: 0 18px 42px rgba(36, 52, 71, 0.12);
    position: relative;
    overflow: hidden;
}

.receptionist-page-header::before {
    content: '';
    position: absolute;
    inset: 0 0 auto 0;
    height: 4px;
    background: linear-gradient(90deg, #EF6F53, #1976d2);
}

.receptionist-page-header > div {
    flex: 1 1;
    text-align: center;
}

.receptionist-eyebrow {
    display: inline-flex;
    color: #EF6F53;
    font-size: 0.76rem;
    font-weight: 900;
    text-transform: uppercase;
    letter-spacing: 0;
    margin-bottom: 4px;
}

.receptionist-container h2 {
    color: #243447;
    font-size: 1.85rem;
    line-height: 1.15;
    font-weight: 900;
    text-transform: uppercase;
    margin: 0;
    overflow-wrap: anywhere;
}

.receptionist-page-header p {
    margin: 5px 0 0;
    color: #66788f;
    font-size: 0.92rem;
    font-weight: 700;
}

.add-receptionist-btn {
    background: linear-gradient(135deg, #EF6F53, #d85a41);
    color: white;
    border: none;
    padding: 8px 14px;
    border-radius: 7px;
    cursor: pointer;
    font-size: 0.92rem;
    font-weight: 800;
    white-space: nowrap;
    box-shadow: 0 10px 22px rgba(239, 111, 83, 0.26);
    transition: transform 160ms ease, box-shadow 160ms ease, filter 160ms ease;
    position: absolute;
    right: 20px;
}

.add-receptionist-btn:hover {
    filter: brightness(1.03);
    transform: translateY(-2px);
    box-shadow: 0 14px 28px rgba(239, 111, 83, 0.32);
}

.receptionist-form {
    padding: 18px;
    border-radius: 8px;
    border: 1px solid rgba(54, 76, 99, 0.08);
    background: rgba(255, 255, 255, 0.97);
    box-shadow: 0 18px 42px rgba(36, 52, 71, 0.11);
    margin-bottom: 20px;
}

.receptionist-form h3 {
    color: #364C63;
    margin-bottom: 5px;
    font-size: 18px;
}

.formm-section {
    display: flex;
    flex-direction: column;
    gap: 5px;
    width: 100%;
}

.form-rowww {
    display: flex;
    gap: 10px;
    margin-bottom: 10px;
    width: 100%;
}

.form-groupppp {
    flex: 1 1;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 5px;
}

.form-groupppp label {
    font-size: 14px;
    font-weight: 800;
    color: #364C63;
    min-width: 120px;
    text-align: right;
}

.form-groupppp .input-container {
    flex: 1 1;
    display: flex;
    position: relative;
}

.form-groupppp input,
.form-groupppp textarea,
.form-groupppp select {
    border: 1px solid rgba(54, 76, 99, 0.18);
    border-radius: 7px;
    font-size: 12px;
    width: 100%;
    padding: 7px 9px;
    background-color: #ffffff;
    transition: border-color 160ms ease, box-shadow 160ms ease;
}

.form-groupppp textarea {
    resize: vertical;
}

.form-groupppp input:focus,
.form-groupppp textarea:focus,
.form-groupppp select:focus {
    outline: none;
    border-color: #1976d2;
    box-shadow: 0 0 0 3px rgba(25, 118, 210, 0.12);
}

.form-groupppp select {
    width: 100%;
    padding: 7px 32px 7px 9px;
    border: 1px solid rgba(54, 76, 99, 0.18);
    border-radius: 7px;
    font-size: 14px;
    background-color: #ffffff;
    cursor: pointer;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-position: right 8px center;
    background-size: 16px;
}

.form-groupppp select:hover {
    border-color: #3498db;
}

.form-groupppp select option {
    padding: 8px;
    font-size: 14px;
}

.form-groupppp select:disabled {
    background-color: #f5f5f5;
    cursor: not-allowed;
    opacity: 0.7;
}

.receptionists-list {
    width: 100%;
    margin-top: 1rem;
    overflow: hidden;
    padding: 18px;
    border: 1px solid rgba(54, 76, 99, 0.08);
    border-radius: 8px;
    background:
        linear-gradient(180deg, rgba(255, 255, 255, 0.98), rgba(248, 251, 255, 0.96));
    box-shadow: 0 18px 42px rgba(36, 52, 71, 0.11);
}

.receptionist-list-title {
    text-align: center;
    margin: 0 0 1rem;
    color: #243447;
    font-size: 1.25rem;
    font-weight: 900;
    text-transform: uppercase;
    position: relative;
    padding-bottom: 9px;
}

.receptionist-list-title::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    width: 72px;
    height: 3px;
    border-radius: 999px;
    background: linear-gradient(90deg, #EF6F53, #1976d2);
    transform: translateX(-50%);
}

.receptionist-cards-container {
    display: flex;
    flex-wrap: nowrap;
    gap: 16px;
    padding: 8px 4px 14px;
    overflow-x: auto;
    scrollbar-width: thin;
    scrollbar-color: #EF6F53 #CFD8DC;
    -webkit-overflow-scrolling: touch;
}

.receptionist-cards-container::-webkit-scrollbar {
    height: 8px;
}

.receptionist-cards-container::-webkit-scrollbar-track {
    background: #CFD8DC;
    border-radius: 4px;
}

.receptionist-cards-container::-webkit-scrollbar-thumb {
    background-color: #EF6F53;
    border-radius: 4px;
}

.receptionist-cards-container::-webkit-scrollbar-thumb:hover {
    background-color: #EF6F53;
}

.receptionist-card {
    background: #ffffff;
    border-radius: 8px;
    border: 1px solid rgba(54, 76, 99, 0.12);
    border-left: 4px solid #EF6F53;
    box-shadow: 0 12px 28px rgba(54, 76, 99, 0.12);
    padding: 0;
    transition: transform 180ms ease, box-shadow 180ms ease, border-color 180ms ease;
    flex: 0 0 auto;
    width: 340px;
    position: relative;
    overflow: hidden;
}

.receptionist-card::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 5px;
    background: linear-gradient(90deg, #EF6F53, #1976d2);
}

.receptionist-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 18px 34px rgba(54, 76, 99, 0.16);
    border-color: rgba(239, 111, 83, 0.28);
}

.receptionist-info {
    padding: 18px 18px 12px;
}

.receptionist-card .receptionist-info h3 {
    color: #243447;
    border-bottom: 0;
    margin: 4px 0 14px;
    padding-bottom: 0;
    font-size: 1.16rem;
    line-height: 1.25;
    font-weight: 900;
    overflow-wrap: anywhere;
}

.receptionist-info p {
    display: grid;
    grid-template-columns: 116px minmax(0, 1fr);
    gap: 8px;
    align-items: start;
    margin: 0 0 8px;
    padding: 8px 10px;
    border-radius: 7px;
    background: #f8fafc;
    border: 1px solid rgba(54, 76, 99, 0.07);
    color: #364C63;
    font-size: 0.9rem;
    text-align: left;
    overflow-wrap: anywhere;
}

.receptionist-info strong {
    color: #24516f;
    font-size: 0.78rem;
    text-transform: uppercase;
    letter-spacing: 0;
}

.receptionist-actions {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-top: 0;
    border-top: 1px solid rgba(54, 76, 99, 0.1);
    padding: 12px 18px 16px;
    background: linear-gradient(180deg, #ffffff, #f8fafc);
}

.receptionist-actions button {
    flex: 1 1;
    min-width: 82px;
    padding: 7px 12px;
    border: none;
    border-radius: 7px;
    cursor: pointer;
    font-size: 13px;
    font-weight: 800;
    transition: transform 160ms ease, filter 160ms ease;
}

.receptionist-actions button:first-child {
    background-color: #24516f;
    color: white;
}

.receptionist-actions button:first-child:hover {
    filter: brightness(1.06);
    transform: translateY(-1px);
}

.receptionist-actions button:last-child {
    background-color: #e74c3c;
    color: white;
}

.receptionist-actions button:last-child:hover {
    filter: brightness(1.04);
    transform: translateY(-1px);
}

.error-message {
    background-color: #fce4e4;
    border: 1px solid #fcc2c3;
    color: #cc0033;
    padding: 1px;
    border-radius: 4px;
    width: fit-content;
    margin:  5px auto;
    font-size: 14px;
}

.success-message {
    background-color: #d4edda;
    border: 1px solid #c3e6cb;
    color: #155724;
    padding: 1px;
    border-radius: 4px;
    width: fit-content;
    margin:  5px auto;
    font-size: 14px;
}

.loading {
    text-align: center;
    padding: 20px;
    color: #666;
    font-size: 16px;
}

.forrm-actions {
    display: flex;
    gap: 5px;
    justify-content: center;
}

.forrm-actions button {
    padding: 7px 14px;
    border: none;
    border-radius: 7px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 800;
    transition: transform 160ms ease, filter 160ms ease;
}

.forrm-actions button[type="submit"] {
    background-color: #24516f;
    color: white;
}

.forrm-actions button[type="submit"]:hover {
    filter: brightness(1.06);
    transform: translateY(-1px);
}

.forrm-actions button[type="button"] {
    background-color: #eef2f6;
    color: #364C63;
    border: 1px solid rgba(54, 76, 99, 0.16);
}

.forrm-actions button[type="button"]:hover {
    filter: brightness(0.98);
    transform: translateY(-1px);
}

.forrm-actions button:active {
    transform: scale(0.98);
}

.receptionist-form .password-toggle {
    position: absolute;
    right: 8px;
    top: 50%;
    transform: translateY(-50%);
    border: 0;
    background: transparent;
    color: #66788f;
    cursor: pointer;
    padding: 4px;
}

.receptionist-form #rec_password {
    padding-right: 36px;
}

@media (max-width: 900px) {
    .receptionist-container {
        padding: 14px;
    }

    .receptionist-page-header {
        align-items: flex-start;
        flex-direction: column;
    }

    .receptionist-page-header > div {
        width: 100%;
    }

    .add-receptionist-btn {
        position: static;
        align-self: center;
    }

    .form-rowww {
        flex-direction: column;
    }

    .form-groupppp {
        align-items: stretch;
        flex-direction: column;
    }

    .form-groupppp label {
        min-width: 0;
        text-align: left;
    }
}

@media (max-width: 560px) {
    .receptionist-container h2 {
        font-size: 1.45rem;
    }

    .add-receptionist-btn {
        width: 100%;
    }

    .receptionist-card {
        width: 290px;
    }

    .receptionist-info p {
        grid-template-columns: 1fr;
        gap: 3px;
    }

    .receptionist-actions {
        justify-content: flex-start;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/routes/Forms/AdminPortal/Receptionist/Receptionist.css"],"names":[],"mappings":"AAAA,0EAA0E;;AAE1E;IACI,iBAAiB;IACjB,8BAA8B;IAC9B,cAAc;IACd,aAAa;IACb,6DAA6D;IAC7D,cAAc;IACd,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR;;yEAEqE;IACrE,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;;;IAGI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,kBAAkB;IAClB,mBAAmB;IACnB,wCAAwC;IACxC,kBAAkB;IAClB;;iFAE6E;IAC7E,8CAA8C;IAC9C,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,WAAW;IACX,oDAAoD;AACxD;;AAEA;IACI,SAAO;IACP,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,SAAS;IACT,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,qDAAqD;IACrD,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,gDAAgD;IAChD,0EAA0E;IAC1E,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,wBAAwB;IACxB,2BAA2B;IAC3B,gDAAgD;AACpD;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,wCAAwC;IACxC,qCAAqC;IACrC,8CAA8C;IAC9C,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,WAAW;AACf;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,SAAO;IACP,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,kBAAkB;AACtB;;AAEA;;;IAGI,wCAAwC;IACxC,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,yBAAyB;IACzB,0DAA0D;AAC9D;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;;IAGI,aAAa;IACb,qBAAqB;IACrB,8CAA8C;AAClD;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,wCAAwC;IACxC,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,wBAAwB;IACxB,qBAAqB;IACrB,yDAA2R;IAC3R,4BAA4B;IAC5B,qCAAqC;IACrC,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,wCAAwC;IACxC,kBAAkB;IAClB;qFACiF;IACjF,8CAA8C;AAClD;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,WAAW;IACX,WAAW;IACX,oBAAoB;IACpB,oDAAoD;IACpD,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,SAAS;IACT,qBAAqB;IACrB,gBAAgB;IAChB,qBAAqB;IACrB,gCAAgC;IAChC,iCAAiC;AACrC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,wCAAwC;IACxC,8BAA8B;IAC9B,8CAA8C;IAC9C,UAAU;IACV,gFAAgF;IAChF,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,WAAW;IACX,oDAAoD;AACxD;;AAEA;IACI,2BAA2B;IAC3B,8CAA8C;IAC9C,sCAAsC;AAC1C;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,2CAA2C;IAC3C,QAAQ;IACR,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,wCAAwC;IACxC,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,eAAe;IACf,8BAA8B;IAC9B,aAAa;IACb,2CAA2C;IAC3C,uBAAuB;IACvB,qDAAqD;AACzD;;AAEA;IACI,SAAW;IACX,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,mDAAmD;AACvD;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,wBAAwB;IACxB,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,wBAAwB;IACxB,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,mDAAmD;AACvD;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,wBAAwB;IACxB,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,wCAAwC;AAC5C;;AAEA;IACI,wBAAwB;IACxB,2BAA2B;AAC/B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,2BAA2B;IAC3B,SAAS;IACT,uBAAuB;IACvB,cAAc;IACd,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,uBAAuB;QACvB,sBAAsB;IAC1B;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;IACtB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,oBAAoB;QACpB,sBAAsB;IAC1B;;IAEA;QACI,YAAY;QACZ,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,0BAA0B;QAC1B,QAAQ;IACZ;;IAEA;QACI,2BAA2B;IAC/B;AACJ","sourcesContent":["/* src/components/routes/Forms/AdminPortal/Receptionist/Receptionist.css */\n\n.receptionist-container {\n    max-width: 1280px;\n    min-height: calc(100vh - 12vh);\n    margin: 0 auto;\n    padding: 24px;\n    background: linear-gradient(180deg, #f4f7fb 0%, #eef4f8 100%);\n    color: #243447;\n    box-sizing: border-box;\n    position: relative;\n    overflow: hidden;\n}\n\n.receptionist-container::before {\n    content: '';\n    position: absolute;\n    inset: 0;\n    background:\n        linear-gradient(135deg, rgba(239, 111, 83, 0.12), transparent 28%),\n        linear-gradient(315deg, rgba(25, 118, 210, 0.1), transparent 34%);\n    pointer-events: none;\n}\n\n.receptionist-container > * {\n    position: relative;\n    z-index: 1;\n}\n\n.receptionist-container *,\n.receptionist-container *::before,\n.receptionist-container *::after {\n    box-sizing: border-box;\n}\n\n.receptionist-page-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 18px;\n    padding: 22px 24px;\n    margin-bottom: 20px;\n    border: 1px solid rgba(54, 76, 99, 0.08);\n    border-radius: 8px;\n    background:\n        linear-gradient(180deg, rgba(255, 255, 255, 0.98), rgba(248, 251, 255, 0.96)),\n        linear-gradient(90deg, rgba(239, 111, 83, 0.1), rgba(25, 118, 210, 0.08));\n    box-shadow: 0 18px 42px rgba(36, 52, 71, 0.12);\n    position: relative;\n    overflow: hidden;\n}\n\n.receptionist-page-header::before {\n    content: '';\n    position: absolute;\n    inset: 0 0 auto 0;\n    height: 4px;\n    background: linear-gradient(90deg, #EF6F53, #1976d2);\n}\n\n.receptionist-page-header > div {\n    flex: 1;\n    text-align: center;\n}\n\n.receptionist-eyebrow {\n    display: inline-flex;\n    color: #EF6F53;\n    font-size: 0.76rem;\n    font-weight: 900;\n    text-transform: uppercase;\n    letter-spacing: 0;\n    margin-bottom: 4px;\n}\n\n.receptionist-container h2 {\n    color: #243447;\n    font-size: 1.85rem;\n    line-height: 1.15;\n    font-weight: 900;\n    text-transform: uppercase;\n    margin: 0;\n    overflow-wrap: anywhere;\n}\n\n.receptionist-page-header p {\n    margin: 5px 0 0;\n    color: #66788f;\n    font-size: 0.92rem;\n    font-weight: 700;\n}\n\n.add-receptionist-btn {\n    background: linear-gradient(135deg, #EF6F53, #d85a41);\n    color: white;\n    border: none;\n    padding: 8px 14px;\n    border-radius: 7px;\n    cursor: pointer;\n    font-size: 0.92rem;\n    font-weight: 800;\n    white-space: nowrap;\n    box-shadow: 0 10px 22px rgba(239, 111, 83, 0.26);\n    transition: transform 160ms ease, box-shadow 160ms ease, filter 160ms ease;\n    position: absolute;\n    right: 20px;\n}\n\n.add-receptionist-btn:hover {\n    filter: brightness(1.03);\n    transform: translateY(-2px);\n    box-shadow: 0 14px 28px rgba(239, 111, 83, 0.32);\n}\n\n.receptionist-form {\n    padding: 18px;\n    border-radius: 8px;\n    border: 1px solid rgba(54, 76, 99, 0.08);\n    background: rgba(255, 255, 255, 0.97);\n    box-shadow: 0 18px 42px rgba(36, 52, 71, 0.11);\n    margin-bottom: 20px;\n}\n\n.receptionist-form h3 {\n    color: #364C63;\n    margin-bottom: 5px;\n    font-size: 18px;\n}\n\n.formm-section {\n    display: flex;\n    flex-direction: column;\n    gap: 5px;\n    width: 100%;\n}\n\n.form-rowww {\n    display: flex;\n    gap: 10px;\n    margin-bottom: 10px;\n    width: 100%;\n}\n\n.form-groupppp {\n    flex: 1;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: 5px;\n}\n\n.form-groupppp label {\n    font-size: 14px;\n    font-weight: 800;\n    color: #364C63;\n    min-width: 120px;\n    text-align: right;\n}\n\n.form-groupppp .input-container {\n    flex: 1;\n    display: flex;\n    position: relative;\n}\n\n.form-groupppp input,\n.form-groupppp textarea,\n.form-groupppp select {\n    border: 1px solid rgba(54, 76, 99, 0.18);\n    border-radius: 7px;\n    font-size: 12px;\n    width: 100%;\n    padding: 7px 9px;\n    background-color: #ffffff;\n    transition: border-color 160ms ease, box-shadow 160ms ease;\n}\n\n.form-groupppp textarea {\n    resize: vertical;\n}\n\n.form-groupppp input:focus,\n.form-groupppp textarea:focus,\n.form-groupppp select:focus {\n    outline: none;\n    border-color: #1976d2;\n    box-shadow: 0 0 0 3px rgba(25, 118, 210, 0.12);\n}\n\n.form-groupppp select {\n    width: 100%;\n    padding: 7px 32px 7px 9px;\n    border: 1px solid rgba(54, 76, 99, 0.18);\n    border-radius: 7px;\n    font-size: 14px;\n    background-color: #ffffff;\n    cursor: pointer;\n    appearance: none;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    background-image: url(\"data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e\");\n    background-repeat: no-repeat;\n    background-position: right 8px center;\n    background-size: 16px;\n}\n\n.form-groupppp select:hover {\n    border-color: #3498db;\n}\n\n.form-groupppp select option {\n    padding: 8px;\n    font-size: 14px;\n}\n\n.form-groupppp select:disabled {\n    background-color: #f5f5f5;\n    cursor: not-allowed;\n    opacity: 0.7;\n}\n\n.receptionists-list {\n    width: 100%;\n    margin-top: 1rem;\n    overflow: hidden;\n    padding: 18px;\n    border: 1px solid rgba(54, 76, 99, 0.08);\n    border-radius: 8px;\n    background:\n        linear-gradient(180deg, rgba(255, 255, 255, 0.98), rgba(248, 251, 255, 0.96));\n    box-shadow: 0 18px 42px rgba(36, 52, 71, 0.11);\n}\n\n.receptionist-list-title {\n    text-align: center;\n    margin: 0 0 1rem;\n    color: #243447;\n    font-size: 1.25rem;\n    font-weight: 900;\n    text-transform: uppercase;\n    position: relative;\n    padding-bottom: 9px;\n}\n\n.receptionist-list-title::after {\n    content: '';\n    position: absolute;\n    bottom: 0;\n    left: 50%;\n    width: 72px;\n    height: 3px;\n    border-radius: 999px;\n    background: linear-gradient(90deg, #EF6F53, #1976d2);\n    transform: translateX(-50%);\n}\n\n.receptionist-cards-container {\n    display: flex;\n    flex-wrap: nowrap;\n    gap: 16px;\n    padding: 8px 4px 14px;\n    overflow-x: auto;\n    scrollbar-width: thin;\n    scrollbar-color: #EF6F53 #CFD8DC;\n    -webkit-overflow-scrolling: touch;\n}\n\n.receptionist-cards-container::-webkit-scrollbar {\n    height: 8px;\n}\n\n.receptionist-cards-container::-webkit-scrollbar-track {\n    background: #CFD8DC;\n    border-radius: 4px;\n}\n\n.receptionist-cards-container::-webkit-scrollbar-thumb {\n    background-color: #EF6F53;\n    border-radius: 4px;\n}\n\n.receptionist-cards-container::-webkit-scrollbar-thumb:hover {\n    background-color: #EF6F53;\n}\n\n.receptionist-card {\n    background: #ffffff;\n    border-radius: 8px;\n    border: 1px solid rgba(54, 76, 99, 0.12);\n    border-left: 4px solid #EF6F53;\n    box-shadow: 0 12px 28px rgba(54, 76, 99, 0.12);\n    padding: 0;\n    transition: transform 180ms ease, box-shadow 180ms ease, border-color 180ms ease;\n    flex: 0 0 auto;\n    width: 340px;\n    position: relative;\n    overflow: hidden;\n}\n\n.receptionist-card::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 5px;\n    background: linear-gradient(90deg, #EF6F53, #1976d2);\n}\n\n.receptionist-card:hover {\n    transform: translateY(-4px);\n    box-shadow: 0 18px 34px rgba(54, 76, 99, 0.16);\n    border-color: rgba(239, 111, 83, 0.28);\n}\n\n.receptionist-info {\n    padding: 18px 18px 12px;\n}\n\n.receptionist-card .receptionist-info h3 {\n    color: #243447;\n    border-bottom: 0;\n    margin: 4px 0 14px;\n    padding-bottom: 0;\n    font-size: 1.16rem;\n    line-height: 1.25;\n    font-weight: 900;\n    overflow-wrap: anywhere;\n}\n\n.receptionist-info p {\n    display: grid;\n    grid-template-columns: 116px minmax(0, 1fr);\n    gap: 8px;\n    align-items: start;\n    margin: 0 0 8px;\n    padding: 8px 10px;\n    border-radius: 7px;\n    background: #f8fafc;\n    border: 1px solid rgba(54, 76, 99, 0.07);\n    color: #364C63;\n    font-size: 0.9rem;\n    text-align: left;\n    overflow-wrap: anywhere;\n}\n\n.receptionist-info strong {\n    color: #24516f;\n    font-size: 0.78rem;\n    text-transform: uppercase;\n    letter-spacing: 0;\n}\n\n.receptionist-actions {\n    display: flex;\n    gap: 8px;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    margin-top: 0;\n    border-top: 1px solid rgba(54, 76, 99, 0.1);\n    padding: 12px 18px 16px;\n    background: linear-gradient(180deg, #ffffff, #f8fafc);\n}\n\n.receptionist-actions button {\n    flex: 1 1 0;\n    min-width: 82px;\n    padding: 7px 12px;\n    border: none;\n    border-radius: 7px;\n    cursor: pointer;\n    font-size: 13px;\n    font-weight: 800;\n    transition: transform 160ms ease, filter 160ms ease;\n}\n\n.receptionist-actions button:first-child {\n    background-color: #24516f;\n    color: white;\n}\n\n.receptionist-actions button:first-child:hover {\n    filter: brightness(1.06);\n    transform: translateY(-1px);\n}\n\n.receptionist-actions button:last-child {\n    background-color: #e74c3c;\n    color: white;\n}\n\n.receptionist-actions button:last-child:hover {\n    filter: brightness(1.04);\n    transform: translateY(-1px);\n}\n\n.error-message {\n    background-color: #fce4e4;\n    border: 1px solid #fcc2c3;\n    color: #cc0033;\n    padding: 1px;\n    border-radius: 4px;\n    width: fit-content;\n    margin:  5px auto;\n    font-size: 14px;\n}\n\n.success-message {\n    background-color: #d4edda;\n    border: 1px solid #c3e6cb;\n    color: #155724;\n    padding: 1px;\n    border-radius: 4px;\n    width: fit-content;\n    margin:  5px auto;\n    font-size: 14px;\n}\n\n.loading {\n    text-align: center;\n    padding: 20px;\n    color: #666;\n    font-size: 16px;\n}\n\n.forrm-actions {\n    display: flex;\n    gap: 5px;\n    justify-content: center;\n}\n\n.forrm-actions button {\n    padding: 7px 14px;\n    border: none;\n    border-radius: 7px;\n    cursor: pointer;\n    font-size: 14px;\n    font-weight: 800;\n    transition: transform 160ms ease, filter 160ms ease;\n}\n\n.forrm-actions button[type=\"submit\"] {\n    background-color: #24516f;\n    color: white;\n}\n\n.forrm-actions button[type=\"submit\"]:hover {\n    filter: brightness(1.06);\n    transform: translateY(-1px);\n}\n\n.forrm-actions button[type=\"button\"] {\n    background-color: #eef2f6;\n    color: #364C63;\n    border: 1px solid rgba(54, 76, 99, 0.16);\n}\n\n.forrm-actions button[type=\"button\"]:hover {\n    filter: brightness(0.98);\n    transform: translateY(-1px);\n}\n\n.forrm-actions button:active {\n    transform: scale(0.98);\n}\n\n.receptionist-form .password-toggle {\n    position: absolute;\n    right: 8px;\n    top: 50%;\n    transform: translateY(-50%);\n    border: 0;\n    background: transparent;\n    color: #66788f;\n    cursor: pointer;\n    padding: 4px;\n}\n\n.receptionist-form #rec_password {\n    padding-right: 36px;\n}\n\n@media (max-width: 900px) {\n    .receptionist-container {\n        padding: 14px;\n    }\n\n    .receptionist-page-header {\n        align-items: flex-start;\n        flex-direction: column;\n    }\n\n    .receptionist-page-header > div {\n        width: 100%;\n    }\n\n    .add-receptionist-btn {\n        position: static;\n        align-self: center;\n    }\n\n    .form-rowww {\n        flex-direction: column;\n    }\n\n    .form-groupppp {\n        align-items: stretch;\n        flex-direction: column;\n    }\n\n    .form-groupppp label {\n        min-width: 0;\n        text-align: left;\n    }\n}\n\n@media (max-width: 560px) {\n    .receptionist-container h2 {\n        font-size: 1.45rem;\n    }\n\n    .add-receptionist-btn {\n        width: 100%;\n    }\n\n    .receptionist-card {\n        width: 290px;\n    }\n\n    .receptionist-info p {\n        grid-template-columns: 1fr;\n        gap: 3px;\n    }\n\n    .receptionist-actions {\n        justify-content: flex-start;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
